import {
  Text,
  Box,
  HStack,
} from "@whoosh/design-system/src/components/primitive";
import { useGetClubCurrency } from "@whoosh/features/src/ClubCurrency";
import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

import { RoundDetailsAnimationWrapper } from "./RoundDetailsAnimationWrapper";

type Fee =
  | {
      readonly amount?: number | null;
      readonly name?: string | null;
    }
  | null
  | undefined;

type BookingFeeListProps = {
  bookingFees: ReadonlyArray<Fee> | Fee[] | null | undefined;
  viewMore: boolean;
};

export const BookingFeeList = ({
  bookingFees,
  viewMore,
}: BookingFeeListProps) => {
  const { currencySymbol } = useGetClubCurrency();
  if (!bookingFees?.length) return null;

  return (
    <RoundDetailsAnimationWrapper enterFrom="bottom" hide={!viewMore}>
      <Box>
        {bookingFees.map((fee, idx) => (
          <Box key={idx}>
            <HStack
              justifyContent="space-between"
              style={{ marginLeft: 36 }}
              alignItems="center"
            >
              <Text variant="mainBaseMedium" color="text-primary">
                {fee?.name}
              </Text>
              <Text
                variant="mainBaseMedium"
                color="text-primary"
                testID={`booking-fee-${fee?.name}`}
              >
                {`${currencySymbol}${ConvertCentsToDollars(fee?.amount ?? 0)}`}
              </Text>
            </HStack>
          </Box>
        ))}
      </Box>
    </RoundDetailsAnimationWrapper>
  );
};
